import { DashboardControlsProvider } from 'contexts/Dashboard/useDashboardControls';
import ViewActionsBar from 'components/Dashboard/ViewActionsBar';
import { DefaultHRSpeedingWidgets, HRSpeedingWidgetsEnum } from './utils';
import HRSpeedingFilterBar from './HRSpeedingFilterBar';
import HRSpeedingDashboard from './HRSpeedingDashboard';

const HRSpeedingPage = () => {
  return (
    <DashboardControlsProvider<HRSpeedingWidgetsEnum>
      storageKey="HRSpeedingDashboard"
      defaultWidgets={DefaultHRSpeedingWidgets}
    >
      <HRSpeedingFilterBar />
      <ViewActionsBar />
      <HRSpeedingDashboard />
    </DashboardControlsProvider>
  );
};

export default HRSpeedingPage;
